import axios from 'axios';
import moment from "moment";
import {downloadFile} from "@/helpers/helpers";
import {getField, updateField} from 'vuex-map-fields';

const getDefaultState = () => {
    return {
        treeComponentKey: 0,
        manufacturers: [],
        userTypes: [
            {id: 1, name: 'Deporprivé', user_type: 'b2b_super_admin', items: [], renderComponent: 0, from: 0, to: 0, total: 0},
            {id: 2, name: 'Cliente', user_type: 'b2b_mayorista', items: [], renderComponent: 0, from: 0, to: 0, total: 0},
            {id: 3, name: 'Cajero Expo', user_type: 'b2b_cajero_expo', items: [], renderComponent: 0, from: 0, to: 0, total: 0},
        ],
        users: {
            items: [],
            from: 0,
            to: 0,
            total: 0
        },
        user: {
            id: null,
            role: {},
            suppliers: [],
            name: null,
            lastname: null,
            job_title: null,
            email: null,
            password: null,
            password_confirmation: null,
            update_password: false,
            exist: false,
            credit_amount: 0,
            manufacturers: [],
        },
        all: [],
        modules: []
    }
}

export const state = getDefaultState();

export const getters = {
    all: (state) => state.all,
    roleName: (state) => {
        let name = ''
        if (state.user.role !== null) {
            name = state.user.role.name
        }
        return name;
    },
    getField
}

export const actions = {
    async fetchUsers({commit}, payload) {
        // payload.pagination.filter.user_type = payload.userType.user_type;
        const {data} = await axios.post(`users/paginate?page=${payload.pagination.currentPage}`, {...payload.pagination});
        commit('SET_USERS', {userType: payload.userType, ...data});
    },
    async fetchManufacturers({ commit }) {
        const response = await axios.post('users/manufacturers',{});
        commit('SET_MANUFACTURERS', response.data);
    },
    async store({commit, state}) {
        await axios.post(`users`, state.user);
        commit('RESET_USER');
    },
    async fetchById({commit}, id) {
        const response = await axios.get(`users/${id}/show`);
        commit('SET_USER', response.data);
    },
    async update({commit, state}) {
        await axios.put(`users`, state.user);
        commit('RESET_USER');
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async delete({commit}, id) {
        await axios.delete(`users/${id}`);
    },
    async recoverAccount({commit}, id) {
        await axios.get(`users/recoverAccount/${id}`);
    },
    resetUser({commit}) {
        commit('RESET_USER');
    },
    resetUserTypes({commit}) {
        commit('RESET_USER_TYPES');
    },
    exist({commit}, exist) {
        commit('SET_EXIST_USER', exist);
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async exportUsers({commit}, filters) {
        const response = await axios.post(`users/export`, filters, {responseType: "blob"});
        const filename = 'usuarios_' + moment().format('YYYY_MM_DD') + '.xlsx';
        downloadFile(filename, response.data);
    },
}

export const mutations = {
    updateField,
    SET_MANUFACTURERS(state, manufacturers) {
        state.manufacturers = manufacturers;
    },
    SET_USERS(state, payload) {
        const indexUser = state.userTypes.findIndex(user => user.user_type === payload.userType.user_type);
        state.userTypes[indexUser] = {
            id: state.userTypes[indexUser].id,
            name: state.userTypes[indexUser].name,
            user_type: getDefaultState().userTypes[indexUser].user_type,
            items: payload.data,
            from: payload.meta.from,
            to: payload.meta.to,
            total: payload.meta.total
        };
    },
    SET_USER(state, user) {
        state.user = {
            id: user.data.id,
            role: user.data.relationships.role,
            suppliers: user.data.relationships.suppliers,
            name: user.data.name,
            lastname: user.data.lastname,
            job_title: user.data.job_title,
            email: user.data.email,
            password: null,
            password_confirmation: null,
            update_password: false,
            credit_amount: user.data.relationships.b2bUser.credit,
            manufacturers: user.data.relationships.b2bUser.manufacturers,
        };
    },
    RESET_USER(state) {
        Object.assign(state.user, getDefaultState().user)
    },
    RESET_USER_TYPES(state) {
        state.userTypes = getDefaultState().userTypes;
    },
    SET_EXIST_USER(state, exist) {
        state.user.exist = exist;
    }
}